export default __webpack_public_path__ + "static/media/commodity_db_icon.9a93abbc.svg";